import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthContext, useAuthProvider } from './hooks/useAuth'
import Layout from './components/Layout'
import LoginPage from './pages/LoginPage'
import SignupPage from './pages/SignupPage'
import Dashboard from './pages/Dashboard'
import WorkoutsPage from './pages/WorkoutsPage'
import ProgressPage from './pages/ProgressPage'
import ClassesPage from './pages/ClassesPage'
import QuestsPage from './pages/QuestsPage'
import LeaderboardPage from './pages/LeaderboardPage'
import ProfilePage from './pages/ProfilePage'
import BillingPage from './pages/BillingPage'

function BillingSuccess() {
  return (
    <div style={{ textAlign: 'center', padding: '3rem 1rem' }}>
      <h2 className="font-pixel" style={{ color: 'var(--accent-green)', fontSize: '1rem', marginBottom: '1rem' }}>
        Payment Successful!
      </h2>
      <p style={{ color: 'var(--text-secondary)', marginBottom: '1.5rem' }}>
        Your subscription is now active. Welcome to the next level!
      </p>
      <a href="/billing" className="btn-primary" style={{ textDecoration: 'none', fontSize: '0.8rem' }}>
        View Your Plan
      </a>
    </div>
  )
}

function BillingCancel() {
  return (
    <div style={{ textAlign: 'center', padding: '3rem 1rem' }}>
      <h2 className="font-pixel" style={{ color: 'var(--gold)', fontSize: '1rem', marginBottom: '1rem' }}>
        Checkout Cancelled
      </h2>
      <p style={{ color: 'var(--text-secondary)', marginBottom: '1.5rem' }}>
        No worries — you can subscribe anytime.
      </p>
      <a href="/billing" className="btn-primary" style={{ textDecoration: 'none', fontSize: '0.8rem' }}>
        Back to Plans
      </a>
    </div>
  )
}

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuthProvider()

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <p className="font-pixel" style={{ color: 'var(--gold)', fontSize: '0.7rem' }}>Loading...</p>
      </div>
    )
  }

  if (!user) return <Navigate to="/login" replace />
  return <>{children}</>
}

export default function App() {
  const auth = useAuthProvider()

  return (
    <AuthContext.Provider value={auth}>
      <Routes>
        <Route path="/login" element={auth.user ? <Navigate to="/" replace /> : <LoginPage />} />
        <Route path="/signup" element={auth.user ? <Navigate to="/" replace /> : <SignupPage />} />
        <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="workouts" element={<WorkoutsPage />} />
          <Route path="progress" element={<ProgressPage />} />
          <Route path="classes" element={<ClassesPage />} />
          <Route path="quests" element={<QuestsPage />} />
          <Route path="leaderboard" element={<LeaderboardPage />} />
          <Route path="billing" element={<BillingPage />} />
          <Route path="billing/success" element={<BillingSuccess />} />
          <Route path="billing/cancel" element={<BillingCancel />} />
          <Route path="profile" element={<ProfilePage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthContext.Provider>
  )
}
